import PostService from '@/services/PostService.js'

export const namespaced = true

export const state = {
	posts: [],
	post: {},
	pageSize: 5,
	isLastEvaluatedKey: {},
	exclusivestartkey: JSON.stringify({})
}

export const mutations = {
	SET_POSTS(state, { posts }) {
		state.posts = state.posts.concat(posts)
	},
	CLEAR_POSTS(state) {
		state.posts = []
	},
	SET_POST(state, { post }) {
		state.post = post
	},
	SET_IS_LAST_EVALUATED_KEY(state, { isLastEvaluatedKey }) {
		state.isLastEvaluatedKey = isLastEvaluatedKey
	},
	SET_EXCLUSIVE_START_KEY(state, { exclusivestartkey }) {
		state.exclusivestartkey = exclusivestartkey
	},
	CLEAR_POST(state) {
		state.post = {}
	}
}

export const actions = {
	async getPosts(
		{ commit, dispatch },
		{ job_id, pageSize, exclusivestartkey }
	) {
		try {
			const response = await PostService.getPosts(
				job_id,
				pageSize,
				exclusivestartkey
			)
			const posts = response.data.items
			const isLastEvaluatedKey = response.data.isLastEvaluatedKey
			const lastPost = posts[posts.length - 1]
			const newExclusivestartkey = isLastEvaluatedKey
				? JSON.stringify({
						post_id: lastPost.post_id,
						job_id: lastPost.job_id,
						create_time_stamp: lastPost.create_time_stamp
				  })
				: JSON.stringify({})
			commit('SET_POSTS', { posts })
			commit('SET_IS_LAST_EVALUATED_KEY', { isLastEvaluatedKey })
			commit('SET_EXCLUSIVE_START_KEY', {
				exclusivestartkey: newExclusivestartkey
			})
			return posts
		} catch (e) {
			console.log(e)
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			console.log(notification)
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	},
	clearPosts({ commit }) {
		commit('CLEAR_POSTS')
	},
	async createPost({ dispatch }, { post }) {
		try {
			await PostService.createPost(post)
			const notification = {
				type: 'success',
				message: `Job Updated`
			}
			dispatch('notification/add', notification, { root: true })
		} catch (e) {
			const notification = {
				type: 'error',
				message: `Oops! Something went wrong.`
			}
			console.log(notification)
			dispatch('notification/add', notification, { root: true })
			console.log(e)
			throw e
		}
	}
}
